<template>
  <div class="ig-feed">
    <div class="ig-grid">
      <v-flex
        v-for="(post, index) in posts"
        :key="post.id"
        class="pa-0 feed-item p-relative"
        :class="{
          largeBlock: index % 4 == 0,
          smallBlock: index % 4 > 1,
        }"
        :style="{backgroundImage: `url(${post.images.standard_resolution.url}`}"
      >
          <a
            class="caption p-absolute"
            :href="post.link"
            target="_blank"
          >
            <v-icon class="icon" size="24px" color="white">fab fa-instagram</v-icon> <br> <br>
            <span v-if="index % 4 == 0" class="text">
              {{post.caption.text.replace(/\r?\n|\r/g, '').replace('..', '').slice(0, 140) + '...'}}
            </span>
          </a>
      </v-flex>
    </div>
  </div>
</template>

<style lang="scss">
.ig-feed {
  .ig-grid {
    display: grid;

    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    grid-auto-rows: 2;

      @media only screen and (min-width: 600px) {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr)) !important;
        grid-auto-rows: minmax(100px, auto) !important;
      }

    .feed-item {
      transform: scale(1);
      z-index: 1;
      position: relative;
      box-shadow: 0px 0px 0px rgba(0, 0, 0, 0);
      display: inline-block;
      padding-top: 100% !important;
      background-size: cover;
      background-position: center center;
      border-radius: 21px;
      width: 100%;
      border: 5px solid white;
      box-sizing: border-box;
      transition: all 0.125s ease;
      &.largeBlock {
        grid-column-end: span 2;
        grid-row-end: span 2;
      }
      &.smallBlock {
        grid-column-end: span 1;
        grid-row-end: span 1;
      }
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: black;
        opacity: 0;
        transition: opacity 0.125s ease;
        border-radius: 17px;
        z-index: 1;
      }
      .caption {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
        text-decoration: none;
        transition: opacity 0.125s ease;
        z-index: 2;
        .icon, .text {
          padding: 8px;
          color: white;
        }
        .text {
          background: white;
          color: black;
          display: block;
          position: absolute;
          margin-left: -5px;
          margin-right: -5px;
          top: calc(100% - 50px);
          transform: translateY(50px);
          transition: all 0.25s ease;
          box-shadow: 0px 21px 21px rgba(0, 0, 0, 0.5);
          border-radius: 0 0 17px 17px;
          font-size: 0.75em;
        }
      }
      &:hover {
        transform: scale(1.15);
        z-index: 99;
        box-shadow: 0px 8px 21px rgba(0, 0, 0, 0.75);
        &:after {
          opacity: 0.45;
        }
        .caption {
          opacity: 1;
          .text {
            transform: translateY(25px);
          }
        }
      }
    }
  }
}
</style>

<script>
export default {
  name: 'igFeed',
  data () {
    return {
      posts: []
    }
  },
  mounted () {
    let vm = this
    fetch('https://api.instagram.com/v1/users/self/media/recent/?access_token=' + process.env.VUE_APP_IG_TOKEN)
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        vm.posts = json.data.slice(0, 10)
      })
  }
}
</script>
